import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";

const DeliveryAddress = () => {
  const { control } = useFormContext();
  const { t } = useTranslation("orders");

  return (
    <Controller
      as={<TextField variant="outlined" fullWidth label={t("list_filter.delivery_address")} />}
      name="deliveryAddress"
      control={control}
      defaultValue=""
    />
  );
};

export default DeliveryAddress;
